'use client'

import { useState } from 'react'

// Renders above the Z2H Applications list in the admin panel. Admins send a
// founder their personal application link by email; the application shell is
// created immediately and shows up in this list as "In Progress".
export function InviteFounderPanel() {
  const [email, setEmail] = useState('')
  const [founderName, setFounderName] = useState('')
  const [ventureName, setVentureName] = useState('')
  const [note, setNote] = useState('')
  const [busy, setBusy] = useState(false)
  const [result, setResult] = useState(null)

  async function send(e) {
    e.preventDefault()
    if (!email.trim() || busy) return
    setBusy(true)
    setResult(null)
    try {
      const res = await fetch('/api/z2h/invite', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim(),
          founderName: founderName.trim() || undefined,
          ventureName: ventureName.trim() || undefined,
          note: note.trim() || undefined,
        }),
      })
      const data = await res.json()
      if (!res.ok || !data.ok) throw new Error(data.error || `HTTP ${res.status}`)
      setResult({
        ok: true,
        message: `Invite ${data.reused ? 're-sent' : 'sent'} to ${email.trim()} (application #${data.applicationId}).`,
        inviteUrl: data.inviteUrl,
      })
      setEmail('')
      setFounderName('')
      setVentureName('')
      setNote('')
    } catch (err) {
      setResult({ ok: false, message: err.message })
    } finally {
      setBusy(false)
    }
  }

  const field = {
    padding: '10px 14px',
    borderRadius: 8,
    border: '1px solid var(--theme-elevation-150)',
    background: 'var(--theme-input-bg)',
    color: 'var(--theme-elevation-800)',
    fontSize: 14,
    minWidth: 0,
  }

  return (
    <div
      style={{
        border: '1px solid var(--theme-elevation-150)',
        borderRadius: 12,
        padding: '20px 24px',
        marginBottom: 24,
        background: 'var(--theme-elevation-50)',
      }}
    >
      <h3 style={{ margin: 0, fontSize: 15 }}>Send a founder the application</h3>
      <p style={{ margin: '6px 0 14px', fontSize: 13, color: 'var(--theme-elevation-500)' }}>
        Emails a personal Zero-to-Hero application link. Re-sending to the same
        email reuses their open application.
      </p>
      <form onSubmit={send} style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        <input
          type="email"
          required
          placeholder="founder@email.com *"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ ...field, flex: '1 1 220px' }}
        />
        <input
          type="text"
          placeholder="Founder name"
          value={founderName}
          onChange={(e) => setFounderName(e.target.value)}
          style={{ ...field, flex: '1 1 160px' }}
        />
        <input
          type="text"
          placeholder="Venture name"
          value={ventureName}
          onChange={(e) => setVentureName(e.target.value)}
          style={{ ...field, flex: '1 1 160px' }}
        />
        <input
          type="text"
          placeholder="Personal note (shown in the email)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          style={{ ...field, flex: '2 1 100%' }}
        />
        <button
          type="submit"
          disabled={busy || !email.trim()}
          style={{
            padding: '10px 22px',
            borderRadius: 8,
            border: 'none',
            background: 'var(--theme-elevation-800)',
            color: 'var(--theme-elevation-0)',
            fontSize: 14,
            fontWeight: 600,
            cursor: busy ? 'wait' : 'pointer',
            opacity: busy || !email.trim() ? 0.6 : 1,
          }}
        >
          {busy ? 'Sending…' : 'Send invite'}
        </button>
      </form>
      {result && (
        <p
          style={{
            margin: '12px 0 0',
            fontSize: 13,
            color: result.ok ? 'var(--theme-success-500, #2e7d32)' : 'var(--theme-error-500, #c62828)',
            wordBreak: 'break-all',
          }}
        >
          {result.message}
          {result.ok && result.inviteUrl ? (
            <>
              {' '}
              <a href={result.inviteUrl} target="_blank" rel="noreferrer">
                {result.inviteUrl}
              </a>
            </>
          ) : null}
        </p>
      )}
    </div>
  )
}
